import { getRoutePoints, transformWindowCoordinateToCanvasCoord } from "./calc";

export const DEFAULT_DOT_COLOR = "black";
export const DEFAULT_DOT_SIZE = 3;
export const DEFAULT_CIRCLE_RADIUS = 3;
export const DEFAULT_CIRCLE_COLOR = "orange";
export const DEFAULT_IMAGE_SIZE = 20;

export const clearRoutes = canvasses => {
  //canvasses.forEach(c => c.getContext("2d").clearRect(0, 0, c.width, c.height));
  for (let [key, c] of Object.entries(canvasses)) {
    c.getContext("2d").clearRect(0, 0, c.width, c.height)
  }
};

export const insertImage = (
  x,
  y,
  canvas,
  imagePath,
  h = DEFAULT_IMAGE_SIZE,
  w = DEFAULT_IMAGE_SIZE
) => {
  let image = new Image();
  image.src = imagePath;
  let mContext = canvas.getContext("2d");
  image.onload = function() {
    mContext.drawImage(image, x, y, DEFAULT_IMAGE_SIZE, DEFAULT_IMAGE_SIZE);
  };
};

export const drawLink = (start, end, context) => {
  context.beginPath();
  context.moveTo(start.xRotated, start.yRotated);
  context.lineTo(end.xRotated, end.yRotated);
  context.lineWidth = 2;
  context.strokeStyle = "#0000FF";
  context.stroke();
};

export const paintDot = (
  context,
  dot,
  color = DEFAULT_DOT_COLOR,
  size = DEFAULT_DOT_SIZE
) => {
  context.fillStyle = color;
  if (size) context.fillRect(dot.xRotated, dot.yRotated, size, size);
  else context.fillRect(dot.xRotated, dot.yRotated, dot.w, dot.h);
};

export const paintCircle = (
  context,
  dot,
  radius = DEFAULT_CIRCLE_RADIUS,
  color = DEFAULT_CIRCLE_COLOR
) => {
  context.beginPath();
  context.arc(dot.xRotated, dot.yRotated, radius, 0, 2 * Math.PI, false);
  context.fillStyle = color;
  context.fill();
};

let context;
let points;
let t = 1;
let onEnd;

export const drawRoute = (nodesArray, canvas, marginTop, onEndAux, config, floor, screenWidth) => {
  onEnd = onEndAux;
  //setup();
  let mContext = canvas.getContext("2d");
  mContext.clearRect(0, 0, canvas.width, canvas.height);
  mContext.fillStyle = "red";
  let mPoints = getRoutePoints(nodesArray, marginTop, config, floor, screenWidth);
  context = mContext;
  points = mPoints;
  t = 1;
  context.lineWidth = 6;
  context.strokeStyle = "#e5104daa";
  if (nodesArray.length > 0) {
    animate();
  }
};

function animate() {
  if (t < points.length - 1) {
    requestAnimationFrame(animate);
  }
  if (points[t - 1] && points[t]) {
    context.beginPath();
    context.setLineDash([5, 20]);
    context.lineJoin = "round"; // Rounded corners
    context.lineCap = "round";  // Rounded ends
    context.moveTo(points[t - 1].x, points[t - 1].y);
    context.lineTo(points[t].x, points[t].y);
    context.stroke();
  } else {
    console.log("points está vacío para t o t-1");
  }
  if (t + 1 === points.length) {
    if(onEnd){
      onEnd();
      onEnd = false;
    }
    return;
  }
  t++;
}
/*
function setup() {
  let lastTime = 0;
  let vendors = ["ms", "moz", "webkit", "o"];
  for (let x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + "RequestAnimationFrame"];
    window.cancelAnimationFrame =
      window[vendors[x] + "CancelAnimationFrame"] ||
      window[vendors[x] + "CancelRequestAnimationFrame"];
  }

  if (!window.requestAnimationFrame)
    window.requestAnimationFrame = function(callback, element) {
      let currTime = new Date().getTime();
      let timeToCall = Math.max(0, 16 - (currTime - lastTime));
      let id = window.setTimeout(function() {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };

  if (!window.cancelAnimationFrame)
    window.cancelAnimationFrame = function(id) {
      clearTimeout(id);
    };
}*/



// WEBPACK FOOTER //
// ./src/utils/canvasPainter.js